import React, {useEffect, useState} from 'react';
import { connect, useDispatch } from 'react-redux';
import debounce from 'lodash.debounce';
import {
    getFiltered,
    startFilteredLoad,
    endFilteredLoad,
    loadMoreItems,
    setWhereFilter,
    setKindFilter,
    setDateFilter, openDropDown,
} from '../../redux/actions/actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { FilteredEventsResponse, County } from '../interfaces';
import {compareFilters, formatDate, getEmptyFilters} from '../../helpers/utils';
import './event-list.scss';
import {Loader} from '../common/';
import EventList from './EventList';
import {BannerType} from '../interfaces';
import LeftBanner from '../common/LeftBanner';
import {filterBuilder, urlBuilder} from "../../helpers/url-builder";
import {useHistory} from "react-router-dom";
import {MainFooter} from '../common/footer'

const LeftColumn = (props: {banners: BannerType[]}) => {
    const { banners } = props;
    return <div className="left-column">
        <LeftBanner banners={banners} />
    </div>
}
const RightColumn = () => {
    return <div className="right-column">
    </div>
}

const Content = (props: any) => {

    const events: FilteredEventsResponse = props.events;
    const {filters, banners} = props;
    let leftBanners = [];
    let listBanners= [];
    //console.log(banners);
    if (banners.total) {
        leftBanners = banners.banners.filter((banner: BannerType) => banner.placement === 'left_side');
        listBanners = banners.banners.filter((banner: BannerType) => banner.placement === 'list_inside')
    }

    const showBanners = filters.start === 0;
    if(events) {
        return <div className="event-list-wrapper">
            { leftBanners && leftBanners.length ? <LeftColumn banners={leftBanners}/> : null }
            <EventList data={events} filters={filters} banners={listBanners} showBanners={showBanners}/>
            { leftBanners && leftBanners.length ? <RightColumn /> : null }

        </div>
    } else {
        return null
    }
}




const PageView = (props: any) => {
    const { filters, filteredEvents, dropDownShow, loadingFilters, counties, categories, banners } = props
    const [ currentFilters, setCurrentFilters ] = useState(getEmptyFilters())
    const [ currentLoadingState, setCurrentLoadingState ] = useState(false);
    const [ showSpinner, setShowSpinner ] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();

    const loadMoreAc = () => {
        dispatch(startFilteredLoad());
        //console.log('loadMoreAc')
        dispatch(loadMoreItems());
    }


    const LoadMore = (props: any) => {
        const { total, filters, spinner } = props;
        const needsShowButton = filters.start + filters.limit < total
        return needsShowButton ? <div className="footer">
            <div
                className="button btn-green"
                onClick={loadMoreAc}
            >
                    <div className="caption">Lae rohkem</div>
                    { spinner ? <div className="spinner"></div> : null}

            </div>
            </div> : null
    }

    const onScroll = debounce(() => {
        if (
            window.innerHeight + document.documentElement.scrollTop
            === document.documentElement.offsetHeight
          ) {
            //console.log('onScroll')
            dispatch(loadMoreItems());
          }
    }, 100);

   // window.addEventListener("scroll", onScroll, false);

    useEffect(() => {
        if (!compareFilters(filters, currentFilters)) {
            setCurrentFilters(filters);
            const {loading} = loadingFilters
            if (filters.start === 0) {
                setCurrentLoadingState(loading)
            }
        }
        if (loadingFilters.loading !== currentLoadingState) {
            if (filters.start === 0) {
                setCurrentLoadingState(loadingFilters.loading)
            }
        }
        if (loadingFilters.loading && filters.start > 0) {
            setShowSpinner(true);
        }
        if (!loadingFilters.loading) {
            setShowSpinner(false);
        }
        // return () => {
        //     window.removeEventListener("scroll", onScroll, false);
        // }
    },[loadingFilters, currentFilters, currentLoadingState, filters]);

    let where, dateF;

    let kind:string[];
    if (filters.where && counties.length) {
        let whereObj = counties.find( (e: County) => e.id === filters.where.replace('city=','').replace('county=',''));
        if (whereObj) {
            where = whereObj.name;
        }
    }
    if (!filters.date && (filters.where || filters.kind)) {
        dateF = formatDate(new Date().getTime()/1000, 'd.M');
    }

    if (filters.date) {
        const formattedD = filters.date.split('=')[1];
        dateF = formatDate(new Date(formattedD).getTime()/1000, 'd.M');
    }
    kind = []
    if (filters.kind) {
        if (categories && categories.data && categories.data.categories) {
            const filtersKind = filters.kind.replace('category=','').split(';')
            kind = filtersKind.map( (elem: string) => {
                const found = categories.data.categories.find( (e:any) => e.slug === elem)
                if (found) {
                    return found.name
                }
            })
        }
    }

    const removeFilterWhere = () => {
        const url = urlBuilder(filterBuilder(filters, '', 'where'))
        dispatch(setWhereFilter(null))
        history.push(url);
    }

    const openDateFilter = () => {
        dispatch(openDropDown(dropDownShow.dropDownShow ? false : 'date'))
    }
    const removeFilterKind = (idx:number) => {
        kind.splice(idx,1)
        let categoryFilter: string|null = null;

        if (kind && kind.length) {
            let slugs = kind.map( (elem: string) => {
                const found = categories.data.categories.find( (e:any) => e.name === elem)
                if (found) {
                    return found.slug
                }
            })
            categoryFilter = `category=${slugs.join(';')}`
        }
        const url = urlBuilder(filterBuilder(filters, categoryFilter || '', 'kind'))
        history.push(url);
        dispatch(setKindFilter(categoryFilter))
    }
    const removeFilterDate = () => {
        dispatch(setDateFilter(null))
    }

    const showDateCleaner = true; //dateF !== formatDate(new Date().getTime()/1000, 'd.M');

    return <React.Fragment>
        { currentLoadingState ?
        <Loader /> :
        !dropDownShow.dropDownShow ?
            <div className='pb-main'>
                <div className="active-filters">
                    <>{ where &&
                        <span className="active-filter">
                            {where}
                            <FontAwesomeIcon
                                onClick={removeFilterWhere}
                                icon={faTimesCircle as any}
                                className='remove-filter'/>
                        </span> }
                    </>
                    <>{ kind && kind.length ?
                        kind.map((misFlt: string, idx:number) =>
                        <span className="active-filter mis-filter">
                            {misFlt } <FontAwesomeIcon
                                onClick={()=>removeFilterKind(idx)}
                                icon={faTimesCircle as any}
                                className='remove-filter'/>
                        </span>) : null}
                    </>
                    <>
                        {dateF &&
                        <span className="active-filter" >
                            <span onClick={openDateFilter}>{dateF}</span>
                            {showDateCleaner &&<FontAwesomeIcon
                                onClick={removeFilterDate}
                                icon={faTimesCircle as any}
                            className='remove-filter'/> }
                        </span> }
                    </>
                </div>
                <Content events={filteredEvents} loading={currentLoadingState} filters={filters} banners={banners}/>
                <LoadMore total={filteredEvents.total} filters={filters} spinner={showSpinner}/>
                <MainFooter />
             </div>
            :null}
        </React.Fragment>

}

const mapStateToProps = (state: any) => {
    return state;
};

export default connect(
    mapStateToProps,
    {getFiltered, startFilteredLoad, endFilteredLoad, loadMoreItems}
  )(PageView);
